import * as React from 'react';
import { useLiveSearchStore } from '@/scopes/search/search/infrastructure/live-search/store';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { createQueryStringSerializer } from '@/scopes/common/infrastructure/query-strings/queryStringSerializer';
import { useHeaderDependencies } from '@/scopes/common/components/Header/dependencies';

const queryStringSerializer = createQueryStringSerializer();

export const useLiveSearch = () => {
  const { query } = useLiveSearchStore();
  const { liveSearchApiClient } = useHeaderDependencies();
  const searchCriteria = {
    query,
  };

  const queryParams = React.useMemo(() => queryStringSerializer.serialize({ query }), [query]);

  return useQuery({
    queryKey: ['live-search-results', queryParams],
    queryFn: () => liveSearchApiClient.getLiveSearchResults(searchCriteria),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    placeholderData: keepPreviousData,
  });
};
